// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project-imports
import auth from "./auth";

import menu from "./menu";
import snackbar from "./snackbar";
import kanban from "./kanban";
import cartReducer from "./cart";
import license from "./license-update";
import licence_renew from "./license-renew";

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  auth,
  menu,
  snackbar,
  kanban,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "able-pro-material-ts-",
    },
    cartReducer
  ),
  license,
  licence_renew,
});

export default reducers;
